
import React from 'react';
import { MarketAlertSettingsManagement } from '@/components/admin/market-alerts/MarketAlertSettingsManagement';

const MarketAlertSettingsPage = () => {
  return <MarketAlertSettingsManagement />;
};

export default MarketAlertSettingsPage;
